import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PrimeReactProvider, addLocale, locale } from 'primereact/api';

import { UA_LOCALE } from './constants';
import AuthProvider from './context/AuthProvider';
import { ShiftProvider } from './context/ShiftProvider';
import PrivateRoute from './router/PrivateRoute';

import Layout from './components/Layout/Layout';
import Authorization from './components/Authorization/Authorization';
import Shift from './components/Shift/Shift';
import NewSale from './components/NewSale/NewSale';
import OpenSales from './components/OpenSales/OpenSales';
import SaleHistory from './components/SaleHistory/SaleHistory';
import SaleDetails from './components/SaleHistory/SaleDetails';
import SaleReturn from './components/SaleReturn/SaleReturn';

// Українська локаль для календаря та інших компонентів PrimeReact.
// Раніше addLocale викликався всередині рендера NewSale на кожен кадр.
addLocale('ua', UA_LOCALE);
locale('ua');

const primeReactConfig = {
    ripple: true,
    // Порожній рядок замість "p-inputtext-sm" тощо — розміри задаються темою.
    inputStyle: 'outlined',
};

function App() {
    return (
        <PrimeReactProvider value={primeReactConfig}>
            <Router>
                <AuthProvider>
                    <ShiftProvider>
                        <Routes>
                            <Route path="/authorization" element={<Authorization />} />
                            <Route element={<PrivateRoute />}>
                                {/* Layout — спільний каркас: шапка, навігація, контейнер */}
                                <Route element={<Layout />}>
                                    <Route path="/shift" element={<Shift />} />
                                    <Route path="/newsale" element={<NewSale />} />
                                    <Route path="/opensales" element={<OpenSales />} />
                                    <Route path="/salehistory" element={<SaleHistory />} />
                                    <Route
                                        path="/salehistory/sale/:id"
                                        element={<SaleDetails />}
                                    />
                                    <Route path="/salereturn" element={<SaleReturn />} />
                                    <Route path="*" element={<Navigate to="/shift" replace />} />
                                </Route>
                            </Route>
                        </Routes>
                    </ShiftProvider>
                </AuthProvider>
            </Router>
        </PrimeReactProvider>
    );
}

export default App;
